import React from "react";

const Footer = () => {

    return (
        <footer className="footer-container">
            <a href="/"><img src='/monbusiness-logo.jpeg' alt="mon business logo" className="brand-logo"/></a>
            <div className="footer-contact_links">
                <a href="mailto:info@monbusinessapp.com" className="email-link">info@monbusinessapp.com</a>
                <a href="/privacypolicy" className="footer-link"> <span id="divider">|</span> Privacy Policy</a>
            </div>
        </footer>
    )
};

export default Footer;